import { ref, type Ref } from 'vue';

interface DialogRef {
    openDialog: () => void;
    closeDialog: () => void;
}

interface UseHistoryDialogReturn {
    dialogRef: Ref<DialogRef | null>;
    setDialogRef: (ref: DialogRef | null) => void;
    open: () => void;
    close: () => void;
}

const dialogRef = ref<DialogRef | null>(null);

export function useHistoryDialog(): UseHistoryDialogReturn {
    function setDialogRef(refValue: DialogRef | null) {
        dialogRef.value = refValue;
    }

    function open() {
        dialogRef.value?.openDialog();
    }

    function close() {
        dialogRef.value?.closeDialog();
    }

    return {
        dialogRef,
        setDialogRef,
        open,
        close,
    };
}
